export default __webpack_public_path__ + "static/media/sn.97b52994.svg";